import { Edit } from "react-admin";
import * as React from "react";
import { CarTuningCreateForm } from "./CarTuningCreate";

export const CarTuningEdit = () => (
  <Edit>
    <CarTuningCreateForm />
  </Edit>
);
